module.exports = __webpack_public_path__ + "media/images/weather/444_night-7dfe9681a8a13b9aed7cac4b2a5109ca.png";